(function ($) {
    window.BrowserPush = {

        _sitename: null,

        initConnection: function (sitename) {

            this._sitename = sitename;

            $(".nav-notifications .menu-panel").hide();

            $(".nav-notifications .bell").on("click", function (e) {

                e.preventDefault();

                if ($(".nav-notifications .menu-panel").hasClass("visible")) {

                    var currentUnreadCount = parseInt($('.notification-count').text());
                    if (currentUnreadCount > 0) {
                        window.BrowserPush.markAllAsRead();
                    }

                    $(".nav-notifications  .menu-panel").removeClass("visible");

                } else {
                    window.BrowserPush.loadFeed();
                    $(".nav-notifications .menu-panel").addClass("visible");
                }

            });

            $(document).on('click', function (event) {
                if (!$(event.target).closest('.nav-notifications').length) {
                    if ($(".nav-notifications  .menu-panel").hasClass("visible")) {
                        var currentUnreadCount = parseInt($('.notification-count').text());
                        if (currentUnreadCount > 0) {
                            window.BrowserPush.markAllAsRead();
                        }
                    }

                    $(".nav-notifications  .menu-panel").removeClass("visible");
                }
            });

            this.countUnreadMessages();
        },

        build: function (feedItem) {

            var template = $('<li class="feed-item has-image"><a class="feed-item-link" href="#"><div class="feed-item-body"><img src="" class="feed-item-image" /><div class="feed-item-content"><span></span><i class="feed-item-time"></i></div></div></a><a class="feed-item-delete" href=\"#\">&times;</a></li>');

            var subTitle = '';
            if (feedItem.subtitle) {
                subTitle = feedItem.subtitle;
            }

            template.find('.feed-item-image').attr('src', feedItem.imageUrl);
            template.find('span').html('<strong>' + feedItem.title + '</strong> ' + subTitle);
            template.find('.feed-item-time').html(feedItem.footer);
            template.find('.feed-item-link').attr('href', feedItem.viewAction.url);
            if (feedItem.viewAction.openInNewTab)
                template.find('.feed-item-link').attr('target', '_blank');
            template.find('.feed-item-delete').attr('href', feedItem.deleteAction.url);

            if (feedItem.badge) {
                var badge = $('<div class="feed-item-badge"></div>');
                badge.html(feedItem.badge.title);
                badge.css('background-color', feedItem.badge.style.backgroundColour);
                badge.css('border-color', feedItem.badge.style.borderColour);
                badge.css('color', feedItem.badge.style.textColour);
                template.find('.feed-item-content span').after(badge);
            }

            return template;
        },

        loadFeed: function () {

            $.ajax({
                url: '/notifications/api/v1/notifications?service=' + this._sitename,
                contentType: "application/json",
                dataType: "json",
                method: "GET",
            }).done(function (data) {
                $(".feed-list").html("");

                if (data.items.length == 0)
                {
                    $(".feed-list").append($('<li class="feed-item empty"><div class="feed-item-body"><div class="feed-item-content"><span>You have no notifications to display</span></div></div></li>'));
                }

                for (var i = 0; i < data.items.length; i++) {

                    var feedItem = data.items[i];

                    $(".feed-list").append(window.BrowserPush.build(feedItem));
                }

                $(".feed-item-delete").on('click', function (e) { e.preventDefault(); window.BrowserPush.deleteFeedItem(this); });
            });
        },

        countUnreadMessages: function ()
        {
            if (document.getElementsByClassName('bell').length == 0) {
                return;
            }

            $.ajax({
                url: '/notifications/api/v1/notifications/unread?service=' + this._sitename,
                contentType: "application/json",
                dataType: "json",
                method: "GET",
            }).done(function (data) {

                if (parseInt(data.unreadCount) > 0) {
                    $('.notification-count').text(data.unreadCount).removeClass('hidden');
                }
            });
        },

        deleteFeedItem: function (target) {

            var parent = $(target).parents(".feed-item");
            var deleteUrl = parent.find('.feed-item-delete').attr('href');

            $(target).addClass("processing");

            $.ajax({
                url: deleteUrl,
                method: "DELETE",
                type: "DELETE",
            }).done(function () {

                parent.remove();
                window.BrowserPush.decrementUnreadCount();
            });
        },

        markAllAsRead: function () {
            $.ajax({
                url: '/notifications/api/v1/notifications/read?service=' + this._sitename,
                method: "PUT",
                type: "PUT",
            }).done(function () {
                $('.feed-item').removeClass('unread-notification');
                $('.notification-count').text(0).addClass("hidden");
            });
        },

        decrementUnreadCount: function () {
            var currentUnreadCount = parseInt($('.notification-count').text());

            if (currentUnreadCount >= 0) {

                currentUnreadCount = currentUnreadCount - 1;
                $('.notification-count').text(currentUnreadCount);

                if (currentUnreadCount == 0) {
                    $('.notification-count').addClass("hidden");
                }
            }
        }
    }

}(jQuery));